<template>
  <editor
    :value="value"
    class="form-control"
    @init="editorInit"
    lang="ftl"
    theme="github"
    height="492"
    v-on="inputListeners"
  />
</template>

<script>
import editor from 'vue2-ace-editor';

export default {
  name: 'BaseEditor',

  components: {
    editor,
  },

  props: {
    value: {
      type: String || Number,
      default: null,
    },
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
      };
    },
  },

  methods: {
    onInput(value) {
      this.$emit('input', value);
    },

    editorInit() {
      /* eslint-disable */
      require('brace/ext/language_tools');
      require('brace/mode/ftl');
      require('brace/theme/github');
      require('brace/ext/searchbox');
      /* eslint-enable */
    },
  },
};
</script>
